module.exports = __webpack_public_path__ + "img/20191107163225830.995fea4f.jpg";